import React from 'react';
import { ChooseMethod, Complete, SetUpDevice } from '../components';
import { GetComponentsForManageMfa } from '@app/models';
import { ManageMfaSteps } from '@app/enums';

export const ManageMfa: React.SFC<GetComponentsForManageMfa> = ({
    isMfaConfigured,
    isOnboarding,
    activeMethod,
    setActiveMethod,
    sourceCancel,
    isDisableButtonNext,
    setIsDisableButtonNext,
    setStepManageMfa,
    setErrorMessage,
    setPassCode,
    errorMessage,
    stepManageMfa,
    passCode,
    setCompleted
}) => {
    const componentsForDialog = {
        [ManageMfaSteps.chooseMethod]: () => (
            <ChooseMethod
                isOnboarding={isOnboarding}
                isMfaConfigured={isMfaConfigured}
                activeMethod={activeMethod}
                setActiveMethod={setActiveMethod}
            />
        ),
        [ManageMfaSteps.setUpDevice]: () => (
            <SetUpDevice
                activeMethod={activeMethod}
                setErrorMessage={setErrorMessage}
                sourceCancel={sourceCancel}
                isDisableButtonNext={isDisableButtonNext}
                setIsDisableButtonNext={setIsDisableButtonNext}
                setStepManageMfa={setStepManageMfa}
                setPassCode={setPassCode}
                passCode={passCode}
                errorMessage={errorMessage}
                setCompleted={setCompleted}
            />
        ),
        [ManageMfaSteps.complete]: () => <Complete activeMethod={activeMethod} />
    };

    return componentsForDialog[stepManageMfa]();
};
